// App.js
import React, { useEffect, useState, useContext, createContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "./App.css";

import VideoImg from "./components/video/VideoImg";
import Login from "./components/auth/Login";
import Navbar from "./components/common/Navbar/Navbar";
import Contact from "./components/contact/Contact";
import Footer from "./components/common/Footer/Footer";
import Playlist from "./components/playlist/Playlist";
import Shorts from "./components/shorts/Shorts";
import TabContent from "./components/tabContent/TabContent";
import About from "./components/about/About";
import Task from "./components/task/Task";
import AboutUs from "./components/aboutus/AboutUs";
import Listing from "./components/gallery/listing/Listing";
import YoutubeAnalytics from "./components/youtubeAnalytics/YoutubeAnalytics";
import QuizDashboard from "./components/quiz/QuizDashboard";
import QuizGame from "./components/quiz/QuizGame";


import { ThemeProvider, ThemeContext } from "./contexts/themeContext";
import { AuthProvider, AuthContext } from "./contexts/authContext";

export const Context = createContext();

function AppContent() {
  const [signedIn, setSignedIn] = useState(false);
  const { isLoggedIn, handleLogin } = useContext(AuthContext);
  const { isDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <Context.Provider value={[signedIn, setSignedIn]}>
      <Router>
        <div className={`App ${isDarkMode ? "dark" : "light"}`}>
          <Navbar isLoggedIn={isLoggedIn} />
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/aim" element={<About />} />
            <Route path="/gallery" element={<Listing />} />
            <Route path="/task" element={<Task />} />



            <Route
              path="*"
              element={
                <>
                  <Playlist />
                  <VideoImg isLoggedIn={isLoggedIn} />
                  <TabContent isLoggedIn={isLoggedIn} />
                  <Shorts isLoggedIn={isLoggedIn} />
                  <YoutubeAnalytics />
                </>
              }
            />

            {/* Quiz Routes handled here or nested */}
            <Route path="/quiz" element={isLoggedIn ? <QuizDashboard /> : <Login onLogin={handleLogin} />} />
            <Route path="/quiz/game/:id" element={isLoggedIn ? <QuizGame /> : <Login onLogin={handleLogin} />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </Context.Provider>
  );
}

function AppWrapper() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default AppWrapper;
